/* @license @google-recaptcha/core v1.0.5 */
var r=function(){return!!document.querySelector('script[src*="/recaptcha/"]:not([src*="gstatic"])')};export{r as checkGoogleReCaptchaInjected};
//# sourceMappingURL=checkGoogleReCaptchaInjected.js.map
